import React from 'react'

import { Box, TableCell, TableRow } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Skeleton } from '@material-ui/lab'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  skeletonLogo: {
    transform: 'scale(1, 1)',
  },
  skeletonCompName: {
    marginLeft: theme.spacing(2),
    transform: 'scale(1, 1)',
  },
  skeletonNumbers: {
    marginLeft: 'auto',
  },
}))

const CompetitorTableLoading = ({ rowsPerPage }) => {
  const styles = useStyles()

  return (
    <React.Fragment>
      {[...Array(rowsPerPage).keys()].map((row, index) => (
        <TableRow
          data-testid={`loading-row-${index}`}
          key={index}
        >
          <TableCell>
            <Skeleton
              variant="circle"
              height={40}
              width={40}
            />
          </TableCell>
          <TableCell>
            <Box
              className={styles.collegeCrestBox}
              display="flex"
              alignItems="center"
            >
              <Skeleton
                className={styles.skeletonLogo}
                height={40}
                width={40}
              />
              <Skeleton
                className={styles.skeletonCompName}
                width="50%"
                height={12}
              />
            </Box>
          </TableCell>
          <TableCell>
            <Skeleton
              className={styles.skeletonNumbers}
              width="45px"
            />
          </TableCell>
          <TableCell>
            <Skeleton
              className={styles.skeletonNumbers}
              width="45px"
            />
          </TableCell>
        </TableRow>
      ))}
    </React.Fragment>
  )
}

CompetitorTableLoading.propTypes = {
  rowsPerPage: PropTypes.number.isRequired,
}

export default CompetitorTableLoading
